import { render } from "./OrderStatusV2.vue?vue&type=template&id=71bfe10c&scoped=true"
import script from "./OrderStatusV2.vue?vue&type=script&lang=ts"
export * from "./OrderStatusV2.vue?vue&type=script&lang=ts"

import "./OrderStatusV2.vue?vue&type=style&index=0&id=71bfe10c&scoped=true&lang=css"
import "./OrderStatusV2.vue?vue&type=style&index=1&id=71bfe10c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-71bfe10c"

export default script